interface PageContainerProps {
    layout: string;
    componentMap:any;
    props?: any;
  }
  
  const PageWrapper: React.FC<PageContainerProps> = ({
    layout,
    componentMap,
    props = {},
  }) => {
    return (
      <>
        {Array?.isArray(layout) &&
          layout.map((comp: string) => {
            const Component = componentMap(comp);
  
            if (!Component) {
              return null;
            }
  
            return <Component key={comp} props={props?.[comp]} />;
          })}
      </>
    );
  };
  
  export default PageWrapper;
  